import { render, staticRenderFns } from "./vFormRender.vue?vue&type=template&id=79a5461c&scoped=true&lang=pug"
import script from "./vFormRender.vue?vue&type=script&lang=js"
export * from "./vFormRender.vue?vue&type=script&lang=js"
import style0 from "./vFormRender.vue?vue&type=style&index=0&id=79a5461c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a5461c",
  null
  
)

export default component.exports